import { render, staticRenderFns } from "./ncform.vue?vue&type=template&id=51ff6886&scoped=true&"
import script from "./ncform.vue?vue&type=script&lang=js&"
export * from "./ncform.vue?vue&type=script&lang=js&"
import style0 from "./ncform.vue?vue&type=style&index=0&id=51ff6886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ff6886",
  null
  
)

export default component.exports